(self["webpackChunkgreen_bubble_theme"] = self["webpackChunkgreen_bubble_theme"] || []).push([["/cart-gift"],{

/***/ "./src/js/cart-gift.js":
/*!*****************************!*\
  !*** ./src/js/cart-gift.js ***!
  \*****************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var giftDataEl = document.getElementById('gift-prerequisite-data');
var giftData = giftDataEl ? JSON.parse(giftDataEl.textContent) : {
  levels: []
};
var giftPrerequisite = giftData.levels;
window.addEventListener('cart:updated', /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
    var cartTotal, eligibleGifts, ineligibleLevels, ineligibleGiftIDs, nonEligibleGifts, tasks, _iterator, _step, level, _iterator2, _step2, _loop, giftItemsInCart, _iterator3, _step3, item, _iterator4, _step4, _item, _t, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          cartTotal = e.detail.cart.total_price / 100;
          eligibleGifts = giftPrerequisite.filter(function (level) {
            return cartTotal >= level.from;
          });
          ineligibleLevels = giftPrerequisite.filter(function (level) {
            return cartTotal < level.from;
          });
          ineligibleGiftIDs = ineligibleLevels.flatMap(function (level) {
            return level.products;
          });
          nonEligibleGifts = e.detail.cart.items.filter(function (item) {
            return ineligibleGiftIDs.includes(item.product_id);
          });
          tasks = []; // Gifts toevoegen
          if (!eligibleGifts.length) {
            _context2.n = 14;
            break;
          }
          _iterator = _createForOfIteratorHelper(eligibleGifts);
          _context2.p = 1;
          _iterator.s();
        case 2:
          if ((_step = _iterator.n()).done) {
            _context2.n = 10;
            break;
          }
          level = _step.value;
          _iterator2 = _createForOfIteratorHelper(level.products);
          _context2.p = 3;
          _loop = /*#__PURE__*/_regenerator().m(function _loop() {
            var productId, isProductInCart;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  productId = _step2.value;
                  isProductInCart = e.detail.cart.items.some(function (item) {
                    return item.id === productId;
                  });
                  if (!isProductInCart) {
                    tasks.push(fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                        items: [{
                          id: productId,
                          quantity: 1,
                          properties: {
                            _free_gift: "true"
                          }
                        }]
                      })
                    }));
                  }
                case 1:
                  return _context.a(2);
              }
            }, _loop);
          });
          _iterator2.s();
        case 4:
          if ((_step2 = _iterator2.n()).done) {
            _context2.n = 6;
            break;
          }
          return _context2.d(_regeneratorValues(_loop()), 5);
        case 5:
          _context2.n = 4;
          break;
        case 6:
          _context2.n = 8;
          break;
        case 7:
          _context2.p = 7;
          _t = _context2.v;
          _iterator2.e(_t);
        case 8:
          _context2.p = 8;
          _iterator2.f();
          return _context2.f(8);
        case 9:
          _context2.n = 2;
          break;
        case 10:
          _context2.n = 12;
          break;
        case 11:
          _context2.p = 11;
          _t2 = _context2.v;
          _iterator.e(_t2);
        case 12:
          _context2.p = 12;
          _iterator.f();
          return _context2.f(12);
        case 13:
          _context2.n = 15;
          break;
        case 14:
          // Alle gifts weghalen
          giftItemsInCart = e.detail.cart.items.filter(function (item) {
            return item.properties && item.properties._free_gift;
          });
          _iterator3 = _createForOfIteratorHelper(giftItemsInCart);
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              item = _step3.value;
              tasks.push(fetch("".concat(window.Shopify.routes.root, "cart/change.js"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0
                })
              }));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        case 15:
          // Non-eligible gifts weghalen
          _iterator4 = _createForOfIteratorHelper(nonEligibleGifts);
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _item = _step4.value;
              tasks.push(fetch("".concat(window.Shopify.routes.root, "cart/change.js"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: _item.key,
                  quantity: 0
                })
              }));
            }

            // Wachten tot ALLE fetches klaar zijn
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          _context2.n = 16;
          return Promise.all(tasks);
        case 16:
          // Meld dat listener klaar is → triggert de reload in je .then()
          if (typeof e.detail.done === "function") {
            e.detail.done();
          }
        case 17:
          return _context2.a(2);
      }
    }, _callee, null, [[3, 7, 8, 9], [1, 11, 12, 13]]);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/js/cart-gift.js"));
/******/ }
]);